import { createSlice } from '@reduxjs/toolkit';

export interface SidebarMessageState {
  show: boolean
}

const getInitialSidebarVisibility = (): boolean => {
  try {
    return localStorage.getItem('showSidebar') === 'true';
  } catch {
    return false;
  }
};

const initialState: SidebarMessageState = {
  show: getInitialSidebarVisibility(),
};

export const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {
    toggleSidebar: (
      state: SidebarMessageState,
    ) => {
      state.show = !state.show;
      localStorage.setItem('showSidebar', state.show.toString());
    },
  },
});

export const { toggleSidebar } = sidebarSlice.actions;

export default sidebarSlice.reducer;
